"use strict";

import { commonConstants, loansConstants } from "../_constants";

const INITIAL_LOAN_DATA_STATE = {
  loansList: [],
  loanActivityList: [],
  isLoanListLoading: false,
  isLoanActivityListLoading: false,
};

export function loans(state = INITIAL_LOAN_DATA_STATE, action) {
  switch (action.type) {
    case loansConstants.LOANS_LIST_REQUEST:
      return {
        ...state,
        isLoanListLoading: true,
        loansList: {
          ...state.loansList,
          list: [],
        },
      };
    case loansConstants.LOANS_LIST_COMPLETE:
      return {
        ...state,
        isLoanListLoading: false,
        loansList: action.payload.data.accountDetails,
      };

    case loansConstants.LOANS_LIST_ERROR:
      return {
        ...state,
        isLoanListLoading: false,
        loansList: [],
      };

    case loansConstants.LOANS_ACTIVITY_LIST_REQUEST:
      return {
        ...state,
        isLoanActivityListLoading: true,
        loanActivityList: [],
      };

    case loansConstants.LOANS_ACTIVITY_LIST_COMPLETE:
      return {
        ...state,
        loanActivityList: action.payload.data?.transactions || [],
        isLoanActivityListLoading: false,
      };

    case loansConstants.LOANS_ACTIVITY_LIST_ERROR:
      return {
        ...state,
        loanActivityList: [],
        isLoanActivityListLoading: false,
      };
  }
  return state;
}
